"use client";
/*
 * Documentation:
 * OldVersionNotification — https://app.subframe.com/4f62853ee923/library?component=OldVersionNotification_2a37eb1d-237d-4ac4-be30-544d938ce09f
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface OldVersionNotificationRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  message?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

const OldVersionNotificationRoot = React.forwardRef<
  HTMLDivElement,
  OldVersionNotificationRootProps
>(function OldVersionNotificationRoot(
  {
    message,
    action,
    className,
    ...otherProps
  }: OldVersionNotificationRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full max-w-[768px] flex-col items-start justify-end gap-2 rounded-lg bg-neutral-50 px-6 py-6 fixed bottom-4 left-1/2 -translate-x-1/2",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex w-full items-center gap-4 justify-between">
        {message ? (
          <span className="text-body-bold font-body-bold text-default-font">
            {message}
          </span>
        ) : null}
        {action ? (
          <div className="flex items-center justify-center gap-4">{action}</div>
        ) : null}
      </div>
    </div>
  );
});

export const OldVersionNotification = OldVersionNotificationRoot;
